import React, { useContext, useEffect, useMemo } from 'react';
import { useTransaction } from '../hooks/_useTransactions';

export const TransactionContext = React.createContext()

export const TransactionProvider = ({ children }) => {
    const transactionState = useTransaction();
    const value = useMemo(() => transactionState, [transactionState])

    //useEffect(() => { console.log("TransactionProvider => ", value) }, [value])

    return (
        <TransactionContext.Provider value={value}>
            {children}
        </TransactionContext.Provider>
    );
}

export function useTransactionContext() {
    return useContext(TransactionContext)
}
